import React, { createContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
	IJobProfileContextProps,
	IJobProfileProviderProps,
	JobRiskFactorError,
	JobRiskFactorsByIdProps,
	JobRiskFactorsProps,
} from './JobProfile.types';
import { JobProfileType } from './JobProfile.enums';

export const JobProfileContext = createContext({} as IJobProfileContextProps);

export const JobProfileProvider = ({ children }: IJobProfileProviderProps) => {
	const { id, jobProfileType, riskId } = useParams() as {
		id: string;
		jobProfileType: JobProfileType;
		riskId: string;
	};
	const [shouldUpdateSummary, setShouldUpdateSummary] = useState(false);
	const [isSummaryMountingLoading, setSummaryMountingLoading] = useState(false);
	const [isSummaryLoading, setSummaryLoading] = useState(false);
	const [selectedPreviousExams, setSelectedPreviousExams] = useState<any[]>([]);
	const [isLoading, setLoading] = useState(false);
	const [riskIndex, setRiskIndex] = useState(0);
	const [focusedId, setFocusedId] = useState('');
	const [jobRiskFactorsById, setJobRiskFactorsById] =
		useState<JobRiskFactorsByIdProps>({
			id: id,
			riskId: '',
			jobRiskFactors: [],
		});
	const [jobRiskFactors, setJobRiskFactors] = useState<JobRiskFactorsProps[]>(
		[],
	);
	const [active, setActive] = useState(0);
	const [jobRiskFactorsError, setJobRiskFactorsError] = useState<
		JobRiskFactorError[]
	>([]);

	return (
		<JobProfileContext.Provider
			value={{
				id,
				jobProfileType,
				riskId,
				jobRiskFactorsById,
				isLoading,
				setLoading,
				setJobRiskFactorsById,
				focusedId,
				setFocusedId,
				riskIndex,
				setRiskIndex,
				jobRiskFactors,
				setJobRiskFactors,
				selectedPreviousExams,
				setSelectedPreviousExams,
				active,
				setActive,
				jobRiskFactorsError,
				setJobRiskFactorsError,
				isSummaryLoading,
				setSummaryLoading,
				shouldUpdateSummary,
				setShouldUpdateSummary,
				isSummaryMountingLoading,
				setSummaryMountingLoading,
			}}
		>
			{children}
		</JobProfileContext.Provider>
	);
};
